import React, { useEffect, useRef } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

// Hooks
import { useAuth } from '../../../hooks/useAuth';

// Utils
import { getDefaultRouteForRole } from '../../../router/utils';
import { getSessionStorageUser } from '../../../utils/sessionStorage';

// Types
import { Role } from '../../../types/auth';

// Components Styled
import { Container } from './styles';

export default function AuthLayout(): JSX.Element {
  const userData = useAuth();
  const syncedRef = useRef(false);

  // Sync auth context from sessionStorage when context is empty.
  // This handles the case where LoginAction writes to sessionStorage directly
  // (without React state update) to avoid router recreation during redirect.
  useEffect(() => {
    if (syncedRef.current) return;
    if (!userData?.user?.user?.id) {
      const stored = getSessionStorageUser();
      if (stored?.user?.id) {
        syncedRef.current = true;
        userData?.setUser(stored);
      }
    }
  }, [userData?.user?.user?.id]);

  // If user is validated, redirect to their default route based on role
  if (userData?.user?.user?.validated) {
    const userRole = userData.user.user.rolActive as Role;
    const defaultRoute = getDefaultRouteForRole(userRole);

    return <Navigate to={defaultRoute} replace />;
  }

  return (
    <Container>
      <Outlet />
    </Container>
  );
}
